import UpdateInvoiceAddressRequestModelBase from '../_generated/modelBases/update-invoice-address-request-model-base';

export default class UpdateInvoiceAddressRequestModel extends UpdateInvoiceAddressRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
